import React from 'react';
import { Badge } from '../components/ui/badge';
import { useStatusPalette, getStatusEntry } from '../utils/statusPalette';

/**
 * Single status chip used everywhere. Pulls colors from the central
 * palette so admin/talent/calendar/reports always show the same.
 */
const StatusChip = ({ status, className = '', size = 'default' }) => {
  const palette = useStatusPalette();
  const entry = getStatusEntry(palette, status);
  const sz = size === 'sm' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5';
  return (
    <Badge
      className={`${entry.bg_class} ${entry.text_class} ${entry.border_class} border font-medium whitespace-nowrap ${sz} ${className}`}
      data-testid={`status-chip-${status}`}
      title={entry.label}
    >
      {entry.label}
    </Badge>
  );
};

export default StatusChip;
